import i18n from "../../../../constants/i18n";
import { USER_DEVICES_HEADERS } from "../../../../constants/table-custom-headers/User";
import getUserDeviceStore from "../../../../stores/user-store/device-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const UserDeviceData = withLiteObserverAndTheme(() => {
  const userDeviceData = getUserDeviceStore().userDevicesData.get();

  return (
    <Et3Table
      columns={USER_DEVICES_HEADERS}
      rows={userDeviceData}
      title={i18n.get("USER_DEVICES_TABLE")}
      shouldBeFlagged={false}
      titleKey={"USER_DEVICES_TABLE"}
    />
  );
});
export default UserDeviceData;
